const subjects = [
    "Mathematics",
    "English Language and Literature",
    "Physics",
    "Chemistry",
    "Biology",
    "History",
    "Geography",
    "Social Studies",
    "Physical Education",
    "Art",
    "Music",
    "Spanish",
    "French",
    "German",
    "Computer Science",
    "Economics",
    "Psychology",
    "Sociology",
    "Philosophy",
    "Political Science",
    "Environmental Science",
    "Health Education",
    "Drama and Theater Arts",
    "Media Studies",
    "Business Studies",
    "Anthropology",
    "Astronomy",
    "Literature",
    "Ethics",
    "Religious Studies",
    "Statistics",
    "Geology",
    "Nutrition and Food Science",
    "Linguistics",
    "Cultural Studies",
    "Archaeology",
    "Human Anatomy and Physiology",
    "Film Studies",
    "Journalism",
    "Architecture",
    "Design and Technology",
    "Civil Engineering",
    "Information Technology",
    "Home Economics",
    "Legal Studies",
    "Horticulture",
    "Sports Science",
    "Communication Studies",
    "Graphic Design",
    "Education Studies",
    "Library and Information Science",
    "Dance",
    "Marine Biology",
    "Veterinary Science",
    "Management",
    "Marketing",
    "Financial Accounting",
    "Managerial Accounting",
    "Organizational Behavior",
    "Human Resource Management",
    "Operations Management",
    "Strategic Management",
    "Entrepreneurship",
    "International Business",
    "Supply Chain Management",
    "Project Management",
    "Business Ethics",
    "Corporate Finance",
    "Business Law",
    "Risk Management",
    "Leadership Studies",
    "Business Communication",
    "E-commerce",
    "Public Relations"
  ];

  export default subjects;
  